import DNavigationItem from "discourse/components/d-navigation-item";
import HorizontalOverflowNav from "discourse/components/horizontal-overflow-nav";
import PluginOutlet from "discourse/components/plugin-outlet";
import bodyClass from "discourse/helpers/body-class";
import icon from "discourse/helpers/d-icon";
import lazyHash from "discourse/helpers/lazy-hash";

const UserCircles = <template>
  {{bodyClass "user-circles-page"}}

  <div
    class="user-navigation user-navigation-secondary circles-user-navigation"
  >
    <HorizontalOverflowNav
      class="activity-nav"
      @desktopClass="action-list activity-list nav-stacked"
    >
      {{#each @controller.types as |tab|}}
        <DNavigationItem
          @route={{tab.route}}
          @model={{tab.model}}
          @ariaCurrentContext="subNav"
          class="user-nav__circles-{{tab.name}}"
          data-name="circles-{{tab.name}}"
        >
          {{#if tab.icon}}{{icon tab.icon}}{{/if}}
          {{tab.title}}
          {{#if tab.count}}<span class="count">({{tab.count}})</span>{{/if}}
        </DNavigationItem>
      {{/each}}
    </HorizontalOverflowNav>
  </div>
  <section class="user-content user-circles-content">
    <PluginOutlet
      @name="user-circles-content"
      @outletArgs={{lazyHash model=@controller.model}}
    >
      {{outlet}}
    </PluginOutlet>
  </section>
</template>;

export default UserCircles;
